export default "https://static-service.opploans-assets.com/assets/webpack/e96ab43d3bf130f54e9ae9ad3cae2b2a.png";